import t from "hastscript";

function n(t, n, r) {
  r.forEach(function (r) {
    n[r] && (t[r] = JSON.parse(JSON.stringify(n[r])));
  });
}

function r(r, e, i) {
  var o = r.children.map(function (r) {
    var o = t(e, i(r)),
        a = o.children[0];
    return n(o, r, ["data", "position"]), n(a, r, ["position"]), o;
  }),
      a = t("tr", o);
  return n(a, r, ["data", "position"]), a;
}

export default function (e, i) {
  if (void 0 === i && (i = {}), "table" !== e.type) return t("table");
  var o = t("table"),
      a = t("thead"),
      u = t("tbody"),
      l = e.children;
  if (n(o, e, ["position", "data"]), 0 === l.length) return o;

  function c(t) {
    return "column" === t.type && i.useColumnLabel && t.label || t.value;
  }

  var d,
      h,
      p = l[0],
      f = l.slice(1),
      s = l;
  return (h = ((d = p) && d.children)[0]) && "column" === h.type && (s = f, a.children.push(r(p, "th", c)), o.children.push(a)), u.children = s.map(function (t) {
    return r(t, "td", c);
  }), o.children.push(u), o;
}